export const PATH = {
    SIGNUP: {
        HOME: '/',
        WELCOME: '/welcome',
        SUBMITTED: '/submitted',
        ACTIVATE: '/activate/:token',
        ACCEPT_INVITE: '/accept-invite/:token',
        STEPS: {
            ONE: '/step-1',
            SEARCH_ORGANIZATION: '/organization-search',
            ADD_ORGANIZATION: '/organization-add',
            CONFIRM_ORGANIZATION: '/confirm',
            INVITE_DONEE: '/invite-donee',
            TWO: '/step-2',
            THREE: '/step-3',
            FOUR: '/step-4',
            FIVE: '/step-5',
            SIX: '/step-6',
            SEVEN: '/step-7',
            FINAL_STEP: '/final-step',
            PASSWORD_STEP: '/password-step',
        },
    },
} as const;
